import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { AppState } from '../../types/store';
import { API_BASE_PATH, PUBLIC_API_BASE_PATH } from '../../constants';

export function getAPIBasePath(state: AppState) {
  if (flagEnabled(state, 'public_papi')) {
    return PUBLIC_API_BASE_PATH;
  }
  return API_BASE_PATH;
}
